export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      buy: "Acheter",
      rent: "Louer",
      blog: "Blogue",
      listProperty: "+ Afficher Propriété",
      contact: "Contactez-nous",
      favorites: "Favoris"
    },
    // Hero
    hero: {
      badge: "Canada",
      title: "Trouvez Votre",
      titleHighlight: "Maison de Rêve",
      subtitle: "Où le cœur rencontre la clé. Découvrez l'endroit parfait à appeler chez vous au Canada.",
      searchPlaceholder: "Toronto, Montréal, Vancouver...",
      searchBtn: "Rechercher",
      buyBtn: "Acheter",
      rentBtn: "Louer",
      listBtn: "Lister une propriété"
    },
    // Featured
    featured: {
      subtitle: "Sélection pour vous",
      title: "Propriétés en Vedette",
      viewAll: "Voir Toutes les Propriétés"
    },
    // Agent CTA
    agentCta: {
      badge: "Pour les agents",
      title: "Vous êtes agent immobilier?",
      subtitle: "Listez vos propriétés sur Dream House et atteignez des milliers d'acheteurs potentiels.",
      features: ["Visibilité maximale", "Gestion facile", "Support dédié"],
      cta: "Commencer maintenant",
      stats: {
        properties: "Propriétés",
        agents: "Agents", 
        visitors: "Visiteurs/mois"
      }
    },
    // Owner CTA
    ownerCta: {
      badge: "Pour les propriétaires",
      title: "Vous êtes propriétaire?",
      subtitle: "Vendez ou louez votre bien rapidement avec Dream House. Nous vous accompagnons à chaque étape.",
      features: ["Estimation gratuite", "Photos professionnelles", "Accompagnement personnalisé"],
      cta: "Publier mon bien"
    },
    // Owner Page
    ownerPage: {
      title: "Publier Votre Annonce",
      subtitle: "Vendez ou louez votre propriété en quelques étapes simples",
      steps: {
        info: "Informations",
        property: "Propriété",
        plan: "Forfait",
        payment: "Paiement"
      },
      form: {
        ownerInfo: "Vos Informations",
        name: "Nom complet",
        email: "Email",
        phone: "Téléphone",
        propertyInfo: "Informations de la Propriété",
        title: "Titre de l'annonce",
        description: "Description détaillée",
        price: "Prix",
        listingType: "Type d'annonce",
        sell: "Vendre",
        rent: "Louer",
        propertyType: "Type de propriété",
        house: "Maison",
        condo: "Condo",
        apartment: "Appartement",
        chalet: "Chalet",
        bedrooms: "Chambres",
        bathrooms: "Salles de bain",
        sqft: "Superficie (pi²)",
        address: "Adresse",
        city: "Ville",
        province: "Province",
        imageUrl: "URL de l'image principale",
        features: "Caractéristiques (séparées par virgule)",
        next: "Suivant",
        previous: "Précédent",
        choosePlan: "Choisissez Votre Forfait",
        perMonth: "/mois",
        popular: "Populaire",
        payWithStripe: "Payer par Carte",
        payWithPaypal: "Payer avec PayPal",
        processing: "Traitement en cours..."
      },
      plans: {
        basic: { name: "Basique", price: "29", features: ["1 annonce", "Photos standard", "Support email"] },
        standard: { name: "Standard", price: "49", features: ["3 annonces", "Photos HD", "Mise en avant", "Support prioritaire"] },
        premium: { name: "Premium", price: "99", features: ["Annonces illimitées", "Photos professionnelles", "Mise en avant premium", "Support VIP", "Statistiques avancées"] }
      },
      success: {
        title: "Paiement Réussi!",
        message: "Votre annonce a été publiée avec succès.",
        viewProperty: "Voir mon annonce"
      }
    },
    // Why Choose
    whyChoose: {
      subtitle: "Pourquoi Dream House?",
      title: "Où le Cœur Rencontre la Clé",
      description: "Chez Dream House, nous croyons que trouver une maison devrait être une aventure excitante, pas une tâche stressante.",
      features: [
        {
          title: "Approche Centrée sur le Cœur",
          description: "Nous comprenons qu'une maison est plus que des murs. C'est là où les souvenirs se créent."
        },
        {
          title: "Les Clés de Votre Avenir",
          description: "Notre équipe d'experts vous guide à chaque étape, de la première visite à la remise des clés."
        },
        {
          title: "Sélection Soignée",
          description: "Chaque propriété est personnellement vérifiée pour assurer qualité, valeur et le parfait ajustement."
        }
      ],
      happyFamilies: "Familles Heureuses"
    },
    // Properties Page
    properties: {
      title: "Toutes les Propriétés",
      subtitle: "Trouvez votre maison idéale parmi notre collection",
      filters: {
        buyRent: "Achat/Location",
        type: "Type",
        city: "Ville",
        beds: "Chambres",
        minPrice: "Prix min",
        maxPrice: "Prix max",
        all: "Tous",
        buy: "Acheter",
        rent: "Louer",
        allTypes: "Tous types",
        house: "Maison",
        condo: "Condo",
        apartment: "Appartement",
        chalet: "Chalet",
        any: "Tous"
      },
      noResults: "Aucune propriété trouvée correspondant à vos critères."
    },
    // Property Card
    propertyCard: {
      forSale: "À Vendre",
      forRent: "À Louer",
      featured: "En Vedette",
      beds: "Chambres",
      baths: "Salles de bain",
      sqft: "pi²",
      viewDetails: "Voir Détails"
    },
    // Property Detail
    propertyDetail: {
      back: "Retour aux propriétés",
      description: "Description",
      features: "Caractéristiques",
      share: "Partager cette propriété:",
      contactAgent: "Contacter l'Agent",
      sendMessage: "Envoyer un Message",
      yourName: "Votre Nom",
      yourEmail: "Votre Email",
      yourPhone: "Votre Téléphone",
      message: "Message",
      send: "Envoyer",
      bedrooms: "Chambres",
      bathrooms: "Salles de bain"
    },
    // List Property
    listProperty: {
      badge: "Pour les agents",
      title: "Lister Votre Propriété",
      subtitle: "Atteignez des milliers d'acheteurs et locataires potentiels",
      steps: {
        account: "Compte",
        plan: "Forfait",
        property: "Propriété"
      },
      step1: {
        title: "Créez Votre Compte",
        subtitle: "Vous avez déjà un compte? Entrez votre email pour continuer.",
        email: "Adresse Email",
        name: "Nom Complet",
        phone: "Numéro de Téléphone",
        continue: "Continuer vers le Forfait"
      },
      step2: {
        title: "Choisissez Votre Forfait",
        subtitle: "Sélectionnez le forfait qui vous convient.",
        popular: "Populaire",
        standard: "Standard",
        professional: "Professionnel",
        perMonth: "par mois",
        standardFeatures: ["Jusqu'à 10 propriétés", "Statistiques de base", "Support par email", "Mise en avant locale"],
        proFeatures: ["Propriétés illimitées", "Statistiques avancées", "Support prioritaire", "Propriétés en vedette"],
        continue: "Continuer"
      },
      step3: {
        title: "Ajoutez Votre Propriété",
        subtitle: "Remplissez les détails de votre propriété.",
        success: "Félicitations! Votre compte est configuré.",
        contactInfo: "Formulaire de propriété bientôt disponible. Contactez-nous à"
      }
    },
    // Contact
    contact: {
      title: "Contactez-Nous",
      subtitle: "Une question ou envie d'en savoir plus sur nos services? Nous serions ravis de vous entendre.",
      getInTouch: "Nous Joindre",
      address: "Adresse",
      phone: "Téléphone",
      email: "Email",
      hours: "Heures",
      hoursValue: "Lun-Ven: 9h-18h\nSam-Dim: 10h-16h",
      sendMessage: "Envoyez-nous un Message",
      yourName: "Votre Nom",
      yourEmail: "Votre Email",
      yourPhone: "Votre Téléphone (optionnel)",
      yourMessage: "Votre Message",
      send: "Envoyer le Message",
      sending: "Envoi en cours..."
    },
    // Blog
    blog: {
      title: "Blogue Dream House",
      subtitle: "Conseils d'experts, analyses du marché et astuces pour acheter, vendre et louer au Canada.",
      loadMore: "Charger Plus d'Articles",
      readMore: "Lire la Suite"
    },
    // Footer
    footer: {
      tagline: "Où le cœur rencontre la clé. Nous vous aidons à trouver l'endroit parfait à appeler chez vous au Canada.",
      proudlyCanadian: "Fièrement Canadien",
      quickLinks: "Liens Rapides",
      contactUs: "Contactez-Nous",
      popularCities: "Villes Populaires",
      copyright: "© 2026 Dream House Canada. Tous droits réservés."
    },
    // Promo Banner
    promoBanner: {
      text: "Listez vos propriétés sur Dream House",
      cta: "Commencer →"
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur s'est produite",
      success: "Succès!",
      messageSent: "Message envoyé avec succès!",
      messageFailed: "Échec de l'envoi du message. Veuillez réessayer."
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      buy: "Buy",
      rent: "Rent",
      blog: "Blog",
      listProperty: "+ List Property",
      contact: "Contact Us",
      favorites: "Favorites"
    },
    // Hero
    hero: {
      badge: "Canada",
      title: "Find Your",
      titleHighlight: "Dream Home",
      subtitle: "Where heart meets key. Discover the perfect place to call home in Canada.",
      searchPlaceholder: "Toronto, Montreal, Vancouver...",
      searchBtn: "Search",
      buyBtn: "Buy",
      rentBtn: "Rent",
      listBtn: "List a Property"
    },
    // Featured
    featured: {
      subtitle: "Hand-Picked For You",
      title: "Featured Properties",
      viewAll: "View All Properties"
    },
    // Agent CTA
    agentCta: {
      badge: "For Agents",
      title: "Are You a Real Estate Agent?",
      subtitle: "List your properties on Dream House and reach thousands of potential buyers.",
      features: ["Maximum Visibility", "Easy Management", "Dedicated Support"],
      cta: "Get Started Now",
      stats: {
        properties: "Properties",
        agents: "Agents",
        visitors: "Visitors/month"
      }
    },
    // Owner CTA
    ownerCta: {
      badge: "For Owners",
      title: "Are You a Property Owner?",
      subtitle: "Sell or rent your property quickly with Dream House. We guide you every step of the way.",
      features: ["Free Estimation", "Professional Photos", "Personalized Support"],
      cta: "List My Property"
    },
    // Owner Page
    ownerPage: {
      title: "Post Your Listing",
      subtitle: "Sell or rent your property in a few simple steps",
      steps: {
        info: "Information",
        property: "Property",
        plan: "Plan",
        payment: "Payment"
      },
      form: {
        ownerInfo: "Your Information",
        name: "Full Name",
        email: "Email",
        phone: "Phone",
        propertyInfo: "Property Information",
        title: "Listing Title",
        description: "Detailed Description",
        price: "Price",
        listingType: "Listing Type",
        sell: "Sell",
        rent: "Rent",
        propertyType: "Property Type",
        house: "House",
        condo: "Condo",
        apartment: "Apartment",
        chalet: "Chalet",
        bedrooms: "Bedrooms",
        bathrooms: "Bathrooms",
        sqft: "Square Feet",
        address: "Address",
        city: "City",
        province: "Province",
        imageUrl: "Main Image URL",
        features: "Features (comma separated)",
        next: "Next",
        previous: "Previous",
        choosePlan: "Choose Your Plan",
        perMonth: "/month",
        popular: "Popular",
        payWithStripe: "Pay by Card",
        payWithPaypal: "Pay with PayPal",
        processing: "Processing..."
      },
      plans: {
        basic: { name: "Basic", price: "29", features: ["1 listing", "Standard photos", "Email support"] },
        standard: { name: "Standard", price: "49", features: ["3 listings", "HD photos", "Featured listing", "Priority support"] },
        premium: { name: "Premium", price: "99", features: ["Unlimited listings", "Professional photos", "Premium featured", "VIP support", "Advanced analytics"] }
      },
      success: {
        title: "Payment Successful!",
        message: "Your listing has been published successfully.",
        viewProperty: "View my listing"
      }
    },
    // Why Choose
    whyChoose: {
      subtitle: "Why Dream House?",
      title: "Where Heart Meets Key",
      description: "At Dream House, we believe finding a home should be an exciting journey, not a stressful task.",
      features: [
        {
          title: "Heart-Centered Approach",
          description: "We understand that a home is more than walls. It's where memories are made."
        },
        {
          title: "Keys to Your Future",
          description: "Our expert team guides you through every step, from first viewing to handing you the keys."
        },
        {
          title: "Curated Selection",
          description: "Every property is personally vetted to ensure quality, value, and that perfect fit."
        }
      ],
      happyFamilies: "Happy Families"
    },
    // Properties Page
    properties: {
      title: "All Properties",
      subtitle: "Find your perfect home from our curated collection",
      filters: {
        buyRent: "Buy/Rent",
        type: "Type",
        city: "City",
        beds: "Beds",
        minPrice: "Min Price",
        maxPrice: "Max Price",
        all: "All",
        buy: "Buy",
        rent: "Rent",
        allTypes: "All Types",
        house: "House",
        condo: "Condo",
        apartment: "Apartment",
        chalet: "Chalet",
        any: "Any"
      },
      noResults: "No properties found matching your criteria."
    },
    // Property Card
    propertyCard: {
      forSale: "For Sale",
      forRent: "For Rent",
      featured: "Featured",
      beds: "Beds",
      baths: "Baths",
      sqft: "sqft",
      viewDetails: "View Details"
    },
    // Property Detail
    propertyDetail: {
      back: "Back to Properties",
      description: "Description",
      features: "Features",
      share: "Share this property:",
      contactAgent: "Contact Agent",
      sendMessage: "Send a Message",
      yourName: "Your Name",
      yourEmail: "Your Email",
      yourPhone: "Your Phone",
      message: "Message",
      send: "Send",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms"
    },
    // List Property
    listProperty: {
      badge: "For Agents",
      title: "List Your Property",
      subtitle: "Reach thousands of potential buyers and renters",
      steps: {
        account: "Account",
        plan: "Plan",
        property: "Property"
      },
      step1: {
        title: "Create Your Account",
        subtitle: "Already have an account? Enter your email to continue.",
        email: "Email Address",
        name: "Full Name",
        phone: "Phone Number",
        continue: "Continue to Plan"
      },
      step2: {
        title: "Choose Your Plan",
        subtitle: "Select the plan that suits you.",
        popular: "Popular",
        standard: "Standard",
        professional: "Professional",
        perMonth: "per month",
        standardFeatures: ["Up to 10 properties", "Basic analytics", "Email support", "Local promotion"],
        proFeatures: ["Unlimited properties", "Advanced analytics", "Priority support", "Featured listings"],
        continue: "Continue"
      },
      step3: {
        title: "Add Your Property",
        subtitle: "Fill in your property details.",
        success: "Congratulations! Your account is set up.",
        contactInfo: "Property form coming soon. Contact us at"
      }
    },
    // Contact
    contact: {
      title: "Contact Us",
      subtitle: "Have a question or want to learn more about our services? We'd love to hear from you.",
      getInTouch: "Get in Touch",
      address: "Address",
      phone: "Phone",
      email: "Email",
      hours: "Hours",
      hoursValue: "Mon-Fri: 9AM-6PM\nSat-Sun: 10AM-4PM",
      sendMessage: "Send us a Message",
      yourName: "Your Name",
      yourEmail: "Your Email",
      yourPhone: "Your Phone (optional)",
      yourMessage: "Your Message",
      send: "Send Message",
      sending: "Sending..."
    },
    // Blog
    blog: {
      title: "Dream House Blog",
      subtitle: "Expert advice, market insights, and tips for buying, selling, and renting in Canada.",
      loadMore: "Load More Articles",
      readMore: "Read More"
    },
    // Footer
    footer: {
      tagline: "Where heart meets key. We help you find the perfect place to call home in Canada.",
      proudlyCanadian: "Proudly Canadian",
      quickLinks: "Quick Links",
      contactUs: "Contact Us",
      popularCities: "Popular Cities",
      copyright: "© 2026 Dream House Canada. All rights reserved."
    },
    // Promo Banner
    promoBanner: {
      text: "List your properties on Dream House",
      cta: "Get Started →"
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      success: "Success!",
      messageSent: "Message sent successfully!",
      messageFailed: "Failed to send message. Please try again."
    }
  }
};
